import { axiosInstance } from "./api";

export default {
  getTypeVariableById: id => axiosInstance.get(`/tipoVariable/${id}`)
};
